import * as setup from '@/setup';
import Button from '@/objects/button';
import * as auth from '@/utils/auth';
import axios from 'axios';
import * as config from '@/config-APP_TARGET';

/**
 * Costanti per il sistema OTP
 */
var OTP_CODE_LENGTH = 4;
var OTP_EXPIRATION_SECONDS = 600; // 10 minuti

export default class Login extends Phaser.Scene {
	constructor() {
		super({ key: 'Login' });
	}

	create(data) {
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var centerY = height / 2;

		// Ricevi challenge_token dai dati della scena (se presente)
		this.challengeToken = (data && data.challenge_token) || null;

		// Background standard come nelle altre scene
		this.add.image(centerX, height / 2, 'background').setOrigin(0.5, 0.5);

		// Logo come nelle altre scene
		this.add.image(centerX, 60, 'logo').setOrigin(0.5, 0.5).setScale(0.45);

		// Stato: 'initial' | 'email-form' | 'code-form'
		this.state = 'initial';

		// Email salvata per verifica OTP
		this.savedEmail = '';

		// Timer per scadenza OTP
		this.otpExpiresAt = 0;
		this.countdownTimer = null;

		// @todo Bottone "login con facebook" - temporaneamente disabilitato
		// this.createFacebookButton(centerX, centerY - 100);

		// @todo Testo "OR" separatore - temporaneamente disabilitato
		// this.add.text(centerX, centerY - 30, 'OR', {
		// 	fontSize: 32,
		// 	fontFamily: 'Luckiest Guy',
		// 	fill: '#FFFFFF',
		// 	align: 'center'
		// }).setOrigin(0.5);

		// Bottone "ACCEDI VIA EMAIL"
		this.createEmailButton(centerX, centerY);
	}

	createFacebookButton(centerX, y) {
		// Bottone Facebook (opzionale, per futuro)
		var fbButton = new Button(
			this,
			centerX,
			y,
			'blue-button',
			1.6,
			'login con facebook',
			false
		);

		fbButton.on('pointerup', function() {
			// @todo Implementare login Facebook
			console.log('Facebook login - da implementare');
		});
	}

	createEmailButton(centerX, y) {
		var scene = this;
		var emailButton = new Button(
			this,
			centerX,
			y,
			'green-button',
			1.6,
			'ACCEDI VIA EMAIL',
			false
		);

		emailButton.on('pointerup', function() {
			if (scene.state === 'initial') {
				scene.showEmailForm();
			}
		});
	}

	showEmailForm() {
		this.state = 'email-form';

		// Rimuovi elementi precedenti se presenti
		this.cleanupUI();

		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var centerY = height / 2;

		// Calcola dimensioni responsive per il form
		var formWidth = Math.min(500, width - 40);
		var inputWidth = Math.min(400, width - 80);

		// Container per il form
		this.emailFormContainer = this.add.container(centerX, centerY);

		// Background semi-trasparente
		var bg = this.add.rectangle(0, 0, formWidth, 400, 0x000000, 0.8);
		bg.setStrokeStyle(3, 0xffffff);

		// Titolo form
		var title = this.add.text(0, -100, 'Inserisci la tua email', {
			fontSize: 32,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center',
			wordWrap: { width: formWidth - 40 }
		}).setOrigin(0.5);

		// Memorizza inputWidth per l'input HTML
		this.inputWidth = inputWidth;

		// Crea subito l'input HTML reale posizionato sopra il form
		this.createEmailInput(centerX, centerY, inputWidth);

		// Bottone Invia - creato separatamente dal container per evitare problemi di posizionamento
		// La classe Button si auto-aggiunge alla scena, quindi non va nel container
		var scene = this;
		this.submitButton = new Button(
			this,
			centerX,
			centerY + 75,
			'green-button',
			1.0,
			'Invia',
			false
		);

		// Gestione input email
		this.emailValue = '';

		this.submitButton.on('pointerup', function() {
			if (scene.emailValue && scene.isValidEmail(scene.emailValue)) {
				scene.requestOtpCode(scene.emailValue);
			} else {
				scene.showError('Inserisci un\'email valida');
			}
		});

		this.emailFormContainer.add([bg, title]);
	}

	/**
	 * Crea l'input HTML per l'email posizionato sopra il form Phaser
	 * @param {number} centerX - Coordinata X del centro del form
	 * @param {number} centerY - Coordinata Y del centro del form
	 * @param {number} inputWidth - Larghezza dell'input in coordinate di gioco
	 */
	createEmailInput(centerX, centerY, inputWidth) {
		// Rimuovi input precedente se presente
		if (this.emailInputElement) {
			document.body.removeChild(this.emailInputElement);
			this.emailInputElement = null;
		}

		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var scene = this;

		// Calcola posizione input basandosi sul canvas
		var canvas = this.sys.game.canvas;
		var canvasRect = canvas.getBoundingClientRect();

		// Calcola il fattore di scala tra le dimensioni del gioco e quelle reali del canvas
		var scaleX = canvasRect.width / width;
		var scaleY = canvasRect.height / height;

		var inputWidthScaled = inputWidth * scaleX;
		var inputHeight = 70 * scaleY;

		// Posizione Y dell'input nel canvas (relativa al centro del form, offset -20)
		var inputY = centerY - 20;

		// Calcola posizione centrata dell'input
		var inputLeft = canvasRect.left + (centerX * scaleX) - (inputWidthScaled / 2);
		var inputTop = canvasRect.top + (inputY * scaleY) - (inputHeight / 2);

		// Crea input HTML
		var input = document.createElement('input');
		input.type = 'email';
		input.placeholder = 'email@example.com';
		input.style.position = 'fixed';
		input.style.left = inputLeft + 'px';
		input.style.top = inputTop + 'px';
		input.style.width = inputWidthScaled + 'px';
		input.style.height = inputHeight + 'px';
		input.style.fontSize = Math.min(32, 24 * scaleX) + 'px';
		input.style.textAlign = 'center';
		input.style.border = '2px solid #4CAF50';
		input.style.borderRadius = '5px';
		input.style.padding = '2px';
		input.style.boxSizing = 'border-box';
		input.style.zIndex = '1000';
		input.style.fontFamily = 'Arial';
		input.style.backgroundColor = '#ffffff';
		input.style.outline = 'none';

		input.addEventListener('input', function(e) {
			scene.emailValue = e.target.value.trim();
		});

		input.addEventListener('keydown', function(e) {
			if (e.key === 'Enter') {
				if (scene.emailValue && scene.isValidEmail(scene.emailValue)) {
					scene.requestOtpCode(scene.emailValue);
					input.blur();
				}
			}
		});

		document.body.appendChild(input);
		this.emailInputElement = input;

		// Focus automatico sull'input dopo un breve delay per garantire il rendering
		setTimeout(function() {
			input.focus();
		}, 100);
	}

	/**
	 * Richiede il codice OTP via email
	 * @param {string} email
	 */
	requestOtpCode(email) {
		var scene = this;
		this.savedEmail = email;

		// Rimuovi input DOM se presente
		if (this.emailInputElement) {
			document.body.removeChild(this.emailInputElement);
			this.emailInputElement = null;
		}

		// Mostra stato di caricamento
		this.showLoading('Invio codice in corso...');

		auth.requestLoginCode(email, this.challengeToken)
			.then(function(response) {
				var data = response.data;
				if (data.success) {
					// Imposta timer scadenza
					scene.otpExpiresAt = Date.now() + (data.expires_in * 1000);
					// Mostra form inserimento codice
					scene.showCodeForm();
				} else {
					scene.showError(data.message || 'Errore durante l\'invio del codice');
					scene.showEmailForm();
				}
			})
			.catch(function(error) {
				console.error('Errore richiesta codice OTP:', error);
				var message = 'Errore durante l\'invio del codice';
				if (error.response && error.response.data && error.response.data.message) {
					message = error.response.data.message;
				}
				scene.showError(message);
				scene.showEmailForm();
			});
	}

	/**
	 * Mostra il form per inserire il codice OTP a 4 cifre
	 */
	showCodeForm() {
		this.state = 'code-form';

		// Rimuovi elementi precedenti
		this.cleanupUI();

		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var centerY = height / 2;

		// Calcola dimensioni responsive per il form
		var formWidth = Math.min(500, width - 40);
		var inputWidth = Math.min(300, width - 80);

		// Container per il form
		this.codeFormContainer = this.add.container(centerX, centerY);

		// Background semi-trasparente
		var bg = this.add.rectangle(0, 0, formWidth, 380, 0x000000, 0.8);
		bg.setStrokeStyle(3, 0xffffff);

		// Titolo form
		var title = this.add.text(0, -140, 'Inserisci il codice', {
			fontSize: 32,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center',
			wordWrap: { width: formWidth - 40 }
		}).setOrigin(0.5);

		// Sottotitolo con email
		var subtitle = this.add.text(0, -100, 'Inviato a: ' + this.savedEmail, {
			fontSize: 18,
			fontFamily: 'Arial',
			fill: '#AAAAAA',
			align: 'center',
			wordWrap: { width: formWidth - 40 }
		}).setOrigin(0.5);

		// Timer countdown
		this.countdownText = this.add.text(0, -60, '', {
			fontSize: 20,
			fontFamily: 'Arial',
			fill: '#f7941e',
			align: 'center'
		}).setOrigin(0.5);

		// Avvia countdown
		this.startCountdown();

		this.codeFormContainer.add([bg, title, subtitle, this.countdownText]);

		// Crea input per codice OTP
		this.createCodeInput(centerX, centerY, inputWidth);

		// Bottone Verifica
		var scene = this;
		this.verifyButton = new Button(
			this,
			centerX,
			centerY + 60,
			'green-button',
			1.0,
			'Verifica',
			false
		);

		this.verifyButton.on('pointerup', function() {
			if (scene.codeValue && scene.codeValue.length === OTP_CODE_LENGTH) {
				scene.verifyOtpCode(scene.codeValue);
			} else {
				scene.showError('Inserisci il codice a ' + OTP_CODE_LENGTH + ' cifre');
			}
		});

		// Link "Invia nuovo codice"
		var resendLink = this.add.text(centerX, centerY + 130, 'Invia nuovo codice', {
			fontSize: 20,
			fontFamily: 'Arial',
			fill: '#4CAF50',
			align: 'center'
		}).setOrigin(0.5).setInteractive({ useHandCursor: true });

		resendLink.on('pointerover', function() {
			resendLink.setStyle({ fill: '#8BC34A' });
		});

		resendLink.on('pointerout', function() {
			resendLink.setStyle({ fill: '#4CAF50' });
		});

		resendLink.on('pointerup', function() {
			scene.requestOtpCode(scene.savedEmail);
		});

		this.resendLink = resendLink;
	}

	/**
	 * Crea l'input HTML per il codice OTP
	 */
	createCodeInput(centerX, centerY, inputWidth) {
		// Rimuovi input precedente se presente
		if (this.codeInputElement) {
			document.body.removeChild(this.codeInputElement);
			this.codeInputElement = null;
		}

		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var scene = this;

		// Calcola posizione input basandosi sul canvas
		var canvas = this.sys.game.canvas;
		var canvasRect = canvas.getBoundingClientRect();

		// Calcola il fattore di scala
		var scaleX = canvasRect.width / width;
		var scaleY = canvasRect.height / height;

		var inputWidthScaled = inputWidth * scaleX;
		var inputHeight = 60 * scaleY;

		// Posizione Y dell'input
		var inputY = centerY - 10;

		// Calcola posizione centrata dell'input
		var inputLeft = canvasRect.left + (centerX * scaleX) - (inputWidthScaled / 2);
		var inputTop = canvasRect.top + (inputY * scaleY) - (inputHeight / 2);

		// Crea input HTML
		var input = document.createElement('input');
		input.type = 'tel';
		input.inputMode = 'numeric';
		input.pattern = '[0-9]*';
		input.maxLength = OTP_CODE_LENGTH;
		input.placeholder = '0000';
		input.autocomplete = 'one-time-code';
		input.style.position = 'fixed';
		input.style.left = inputLeft + 'px';
		input.style.top = inputTop + 'px';
		input.style.width = inputWidthScaled + 'px';
		input.style.height = inputHeight + 'px';
		input.style.fontSize = Math.min(40, 32 * scaleX) + 'px';
		input.style.textAlign = 'center';
		input.style.letterSpacing = '15px';
		input.style.border = '3px solid #00659d';
		input.style.borderRadius = '5px';
		input.style.padding = '5px';
		input.style.boxSizing = 'border-box';
		input.style.zIndex = '1000';
		input.style.fontFamily = 'Courier New, monospace';
		input.style.fontWeight = 'bold';
		input.style.backgroundColor = '#ffffff';
		input.style.outline = 'none';

		this.codeValue = '';

		input.addEventListener('input', function(e) {
			// Accetta solo numeri
			var value = e.target.value.replace(/[^0-9]/g, '');
			e.target.value = value;
			scene.codeValue = value;

			// Auto-submit quando inserite tutte le cifre
			if (value.length === OTP_CODE_LENGTH) {
				scene.verifyOtpCode(value);
			}
		});

		input.addEventListener('keydown', function(e) {
			if (e.key === 'Enter') {
				if (scene.codeValue && scene.codeValue.length === OTP_CODE_LENGTH) {
					scene.verifyOtpCode(scene.codeValue);
					input.blur();
				}
			}
		});

		document.body.appendChild(input);
		this.codeInputElement = input;

		// Focus automatico
		setTimeout(function() {
			input.focus();
		}, 100);
	}

	/**
	 * Avvia il countdown per la scadenza del codice
	 */
	startCountdown() {
		var scene = this;

		// Ferma timer precedente se presente
		if (this.countdownTimer) {
			clearInterval(this.countdownTimer);
		}

		var updateCountdown = function() {
			var remaining = Math.max(0, scene.otpExpiresAt - Date.now());
			var minutes = Math.floor(remaining / 60000);
			var seconds = Math.floor((remaining % 60000) / 1000);

			if (remaining <= 0) {
				scene.countdownText.setText('Codice scaduto');
				scene.countdownText.setStyle({ fill: '#FF0000' });
				clearInterval(scene.countdownTimer);

				// Disabilita input
				if (scene.codeInputElement) {
					scene.codeInputElement.disabled = true;
					scene.codeInputElement.style.backgroundColor = '#eeeeee';
				}
			} else {
				var timeStr = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
				scene.countdownText.setText('Scade tra: ' + timeStr);
			}
		};

		updateCountdown();
		this.countdownTimer = setInterval(updateCountdown, 1000);
	}

	/**
	 * Verifica il codice OTP inserito
	 * @param {string} code
	 */
	verifyOtpCode(code) {
		var scene = this;

		// Disabilita input durante verifica
		if (this.codeInputElement) {
			this.codeInputElement.disabled = true;
		}

		this.showLoading('Verifica in corso...');

		auth.verifyOtpCode(code, this.savedEmail)
			.then(function(response) {
				var data = response.data;

				if (data.success && data.token) {
					// Salva token JWT
					auth.saveToken(data.token);

					// Salva dati utente
					if (data.user) {
						auth.saveUser(data.user);
					}

					// Pulisci UI
					scene.cleanupUI();

					// Avvia il gioco
					scene.startGame();
				} else {
					scene.hideLoading();
					scene.showError(data.message || 'Codice non valido');

					// Riabilita input
					if (scene.codeInputElement) {
						scene.codeInputElement.disabled = false;
						scene.codeInputElement.value = '';
						scene.codeInputElement.focus();
					}
					scene.codeValue = '';
				}
			})
			.catch(function(error) {
				console.error('Errore verifica OTP:', error);
				scene.hideLoading();

				var message = 'Codice non valido o scaduto';
				var attemptsRemaining = null;

				if (error.response && error.response.data) {
					if (error.response.data.message) {
						message = error.response.data.message;
					}
					if (error.response.data.attempts_remaining !== undefined) {
						attemptsRemaining = error.response.data.attempts_remaining;
					}
					if (error.response.data.lockout_remaining !== undefined) {
						// Utente bloccato
						var lockoutMinutes = Math.ceil(error.response.data.lockout_remaining / 60);
						message = 'Troppi tentativi. Riprova tra ' + lockoutMinutes + ' minuti.';
					}
				}

				if (attemptsRemaining !== null && attemptsRemaining > 0) {
					message += ' (' + attemptsRemaining + ' tentativi rimasti)';
				}

				scene.showError(message);

				// Riabilita input se non bloccato
				if (scene.codeInputElement && !error.response || (error.response && error.response.status !== 429)) {
					scene.codeInputElement.disabled = false;
					scene.codeInputElement.value = '';
					scene.codeInputElement.focus();
				}
				scene.codeValue = '';
			});
	}

	/**
	 * Mostra messaggio di caricamento
	 */
	showLoading(message) {
		this.hideLoading();

		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;

		this.loadingText = this.add.text(centerX, height - 200, message, {
			fontSize: 24,
			fontFamily: 'Arial',
			fill: '#FFFFFF',
			align: 'center'
		}).setOrigin(0.5);
	}

	/**
	 * Nasconde messaggio di caricamento
	 */
	hideLoading() {
		if (this.loadingText) {
			this.loadingText.destroy();
			this.loadingText = null;
		}
	}

	/**
	 * Pulisce tutti gli elementi UI
	 */
	cleanupUI() {
		// Rimuovi input email DOM
		if (this.emailInputElement) {
			document.body.removeChild(this.emailInputElement);
			this.emailInputElement = null;
		}

		// Rimuovi input codice DOM
		if (this.codeInputElement) {
			document.body.removeChild(this.codeInputElement);
			this.codeInputElement = null;
		}

		// Rimuovi bottone submit
		if (this.submitButton) {
			this.submitButton.destroy();
			this.submitButton = null;
		}

		// Rimuovi bottone verifica
		if (this.verifyButton) {
			this.verifyButton.destroy();
			this.verifyButton = null;
		}

		// Rimuovi container email form
		if (this.emailFormContainer) {
			this.emailFormContainer.destroy();
			this.emailFormContainer = null;
		}

		// Rimuovi container code form
		if (this.codeFormContainer) {
			this.codeFormContainer.destroy();
			this.codeFormContainer = null;
		}

		// Rimuovi link resend
		if (this.resendLink) {
			this.resendLink.destroy();
			this.resendLink = null;
		}

		// Ferma timer countdown
		if (this.countdownTimer) {
			clearInterval(this.countdownTimer);
			this.countdownTimer = null;
		}

		// Nascondi loading
		this.hideLoading();
	}

	destroy() {
		// Rimuovi input DOM quando la scena viene distrutta
		this.cleanupUI();
		super.destroy();
	}

	isValidEmail(email) {
		var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	}

	/**
	 * Metodo chiamato quando l'utente completa il login
	 * Avvia il gioco
	 */
	startGame() {
		// Salva challenge_token nel registry se presente, per recuperarlo in Boot dopo SplashScreen
		if (this.challengeToken) {
			this.registry.set('pending_challenge_token', this.challengeToken);
		}

		// Avvia SplashScreen che poi avvierà Boot
		this.scene.start('SplashScreen');
	}

	showError(message) {
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var scene = this;

		var errorText = this.add.text(centerX, height - 150, message, {
			fontSize: 24,
			fontFamily: 'Arial',
			fill: '#FF0000',
			align: 'center',
			wordWrap: { width: width - 40 }
		}).setOrigin(0.5);

		// Rimuovi errore dopo 4 secondi
		this.time.delayedCall(4000, function() {
			if (errorText && errorText.active) {
				errorText.destroy();
			}
		});
	}
}
